var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-6 md:py-12"},[_c('div',{staticClass:"container mx-auto px-4"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }